import { stringLitArray } from "../utils/utilsT";


export interface PaymentCardT {
    id: number
    cardType: string
    cardNumberMasked: string
    cardName: string
    funding: string
    // defaultCardId?: number
    primaryCard?: number
}

export const initObjectPaymentCard: PaymentCardT = {
    id: null,
    cardType: "",
    cardNumberMasked: "",
    cardName: "",
    funding: "",
    // defaultCardId: null,
    primaryCard: null
}